import React from "react";
import { Route, Routes } from "react-router-dom";
import Folder from "../Pages/Folder";
import InnerCollection from "../Pages/collection/InnerCollection";
import Image from "../Pages/Image/Image";
import Innerfolder from "../Pages/folder/Innerfolder";
import InsideCollectionView from "../Pages/collection/insisecollectionview";
const Layout = () => {
  return (
    <>
      <Routes>
        <Route path="/folder/:id" element={<Innerfolder />} />
        <Route path="/collection/:id" element={<InnerCollection />} />
        <Route path="/collection/view/:id" element={<InsideCollectionView />} />
        <Route path="/assets/:id" element={<Image />} />
        <Route path="/assets/*" element={<Image />} />
        <Route path="/:comSlug/folder/:id" element={<Innerfolder />} />
        <Route path="/:comSlug/collection/:id" element={<InnerCollection />} />
        <Route
          path="/:comSlug/collection/view/:id"
          element={<InsideCollectionView />}
        />
        <Route path="/:comSlug/assets/:id" element={<Image />} />
        <Route path="/:comSlug/assets/*" element={<Image />} />
      </Routes>
    </>
  );
};

export default Layout;
